import { useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { triggerHaptic } from "@/utils/haptics";
import { MobileNavSheet } from "./MobileNavSheet";

export const MobileNavMenu = () => {
  const [open, setOpen] = useState(false);

  const openMenu = () => {
    triggerHaptic("medium");
    setOpen(true);
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden p-3 h-12 w-12"
        onClick={openMenu}
        aria-label="Öppna meny"
        aria-expanded={open}
        aria-controls="mobile-navigation-menu"
      >
        <Menu className="h-7 w-7" />
      </Button>

      <MobileNavSheet open={open} onOpenChange={setOpen} />
    </>
  );
};
